import makeStyles from '@mui/styles/makeStyles';

// istanbul ignore next
const useStyles = makeStyles(
    (theme) => ({
        address: { maxWidth: '80%', textAlign: 'right' },
        alignRight: {
            textAlign: 'right',
        },
        auctionDate: {
            color: theme.palette.secondary.main + '99',
            fontWeight: 500,
        },
        auctionDetailsContactInfo: { marginBottom: theme.spacing(3) },
        auctionDetailsContactInfoItem: {
            alignSelf: 'center',
            marginBottom: theme.spacing(1),
        },
        auctionDetailsContainer: { border: '1px solid #E5E8EB', width: '100%' },
        auctionDetailsInfoContainer: {
            padding: theme.spacing(9),
            paddingBottom: theme.spacing(5),
            paddingTop: theme.spacing(3),
        },
        auctionDetailsMoreLotsButton: { marginTop: theme.spacing(9), width: '100%' },
        auctionDetailsTitle: {
            margin: 0,
            padding: theme.spacing(9),
            paddingBottom: theme.spacing(3),
            paddingTop: theme.spacing(5),
        },
        auctionName: {
            height: 40,
            overflow: 'hidden',
        },
        auctioneerCompany: {
            height: 20,
            overflow: 'hidden',
        },
        bidOnlineButton: {
            marginRight: 15,
            width: '50%',
        },
        bidOnlineContainer: {
            marginBottom: theme.spacing(3),
            marginTop: theme.spacing(3),
        },
        bidOnlineIcon: {
            marginRight: theme.spacing(2),
        },
        bold: { fontWeight: 'bold' },
        contactButton: {
            backgroundColor: theme.palette.common.white,
            width: '50%',
        },
        detailRow: {
            '& :first-child': {
                marginRight: 4,
            },
            paddingBottom: theme.spacing(1),
            paddingTop: theme.spacing(1),
        },
        fullWidthHr: {
            margin: '0px -16px 10px',
        },
        lozenges: {
            '& > :first-child': {
                margin: '0px 5px',
            },
            marginBottom: 9,
        },
        mediumBold: { fontWeight: 500 },
        outlineButton: {
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
        },
        semiBold: { fontWeight: 600 },
        showMoreDetailsButton: {
            color: theme.palette.secondary.light,
        },
        summaryTitle: {
            fontSize: theme.spacing(7),
            margin: 0,
        },
    }),
    { index: 1 }
);

export default useStyles;
